import { Alert } from './Alert';
const meta = {
    title: 'Features/Alert',
    component: Alert,
    parameters: { layout: 'padded' },
    argTypes: {
        variant: { control: 'select', options: ['info', 'success', 'warning', 'error', 'neutral'] },
        dismissible: { control: 'boolean' }
    }
};
export default meta;
export const Info = {
    args: { variant: 'info', message: 'Backflows now have their own Backflows tab.' }
};
export const Dismissible = {
    args: { variant: 'warning', message: 'Two component types are missing a default quantity.', dismissible: true }
};
export const WithTitle = {
    args: { variant: 'info', title: 'Heads up', message: 'Changes here apply to every building in this account.' }
};
